import React from "react";
import Str from "shared/components/Str";
import classnames from "classnames";

import _str from "shared/util/_str";
import Actions from "okpay/actions/Actions";
import TextInput from "okpay/util/TextInput";

const SecurityCodeHelp = (props) => {
	return (
		<span className="okpay-securitycode-help">
			<span className="okpay-securitycode-tooltip">
				<Str>
					The CVV is a 3-digit code on the back of your card. On Amex, it’s a
					4-digit code on the front.
				</Str>
			</span>
		</span>
	);
};

class SecurityCode extends React.Component {
	_onChange = (e) => {
		const { value } = e.target;
		Actions.updateField({ securityCode: value });
	};

	render() {
		const classes = classnames({
			"okpay-item": true,
			"okpay-item-securitycode": true,
		});

		return (
			<div className={classes}>
				<div className="okpay-item-element">
					<TextInput
						value={this.props.value}
						name="securityCode"
						label={_str("CVV")}
						maxLength={4}
						autoComplete="on"
						onChange={this._onChange}
					/>
				</div>
				<SecurityCodeHelp />
			</div>
		);
	}
}

export default SecurityCode;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/fields/SecurityCode.jsx